import WT from "@sscale/wtsdk";
import WTDiagnostic from "@sscale/wtsdk/dist/WTWebDiagnostics";

// SESSION

const connect = (token, userName, constraints) => {
    const metaData = {
        networkTopology: 'media-server',
    };
    WT.Session.connect(token, (userName || 'Oleh'), constraints, metaData);
}

const connectWithoutPublish = (token, userName, audioOnly, constraints) => {
    const metaData = {
        networkTopology: 'media-server',
    };
    WT.Session.connectWithoutPublish(token, userName, audioOnly ? {audio: true, video: false} : constraints, metaData);
}

const connectAsViewer = (token, userName) => {
    WT.Session.connectAsAViewer(token, (userName || 'Oleh'));
}

const disconnect = () => {
    WT.Session.disconnect()
}

const listenWtError = (cb) => {
    WT.ErrorsListeners.onSessionError(cb)
}
const onConnected = (cb) => {
    WT.SessionListeners.onConnected(cb)
}
const onLocalConnectionResumed = (cb) => {
    WT.ReconnectListeners.onLocalConnectionResumed(cb)
}

const enableWTStats = () => {
    WT.Session.enableStats();
}
const onMosReport = (cb) => {
    WT.SessionListeners.onMosReport(cb)
}

const setWTAudioConstraints = (constraints) => {
    WT.setAudioConstraints(constraints)
}
const setWTVideoConstraints = (constraints) => {
    WT.setVideoConstraints(constraints)
}

// STREAM
const onLocalStreamCreated = (cb) => {
    WT.SessionListeners.onLocalStreamCreated(cb)
}
const onStreamCreated = (cb) => {
    WT.SessionListeners.onStreamCreated(cb)
}
const setMediaQuality = (width, height, frameRate) => {
    WT.Participant.setMediaQuality({videoWidth: width, videoHeight: height, frameRate})
}

// PARTICIPANT

const onParticipantJoin = (cb) => {
    WT.ParticipantListeners.onParticipantJoin(cb)
}
const onParticipantLeft = (cb) => {
    WT.ParticipantListeners.onParticipantLeft(cb)
}
const onParticipantRejected = (cb) => {
    WT.ParticipantListeners.onParticipantRejected(cb)
}
const disableAudio = () => {
    WT.Participant.disableAudio();
}
const enableAudio = () => {
    WT.Participant.enableAudio();
}
const disableVideo = () => {
    WT.Participant.disableVideo();
}
const enableVideo = () => {
    WT.Participant.enableVideo();
}
const startScreenSharing = async (participantId) => {
    await WT.Participant.startScreenSharing('video-' + participantId);
}
const stopScreenSharing = (participantId) => {
    WT.Participant.stopScreenSharing('video-' + participantId);
}
const pStartSpeaking = (cb) => {
    WT.ParticipantListeners.onParticipantSpeaking(cb)
}
const pStopSpeaking = (cb) => {
    WT.ParticipantListeners.onParticipantStopSpeaking(cb)
}
const pMediaStreamChanged = (cb) => {
    WT.ParticipantListeners.onParticipantMediaStreamChanged(cb)
}

// REMOTE PARTICIPANT
const publishRemoteParticipant = (participantId) => {
    WT.Participant.publishRemoteParticipant(participantId);
}
const disconnectRemoteP = (participantId) => {
    WT.Participant.disconnectRemoteParticipant(participantId)
}

const toggleWTRemoteVideo = (participantId) => {
    WT.Participant.toggleRemoteVideo(participantId);
}

const toggleWTRemoteAudio = (participantId) => {
    WT.Participant.toggleRemoteAudio(participantId);
}

const enabledVideoStatsList = {};
const enableWTVideoStats = (videoElement, cb) => {
    if(!enabledVideoStatsList[videoElement.id]) {
        enabledVideoStatsList[videoElement.id] = new WTDiagnostic.VideoFrameChecker(videoElement, cb);
    }
}

const disableWTVideoStats = (videoElement) => {
    if(enabledVideoStatsList[videoElement.id]) {
        enabledVideoStatsList[videoElement.id].stop();
        delete enabledVideoStatsList[videoElement.id];
    }
};

const isRemoteWTVideoEnabled = (participantId) => {
    return WT.Participant.isRemoteVideoEnabled(participantId)
}
const isRemoteWTAudioEnabled = (participantId) => {
    return WT.Participant.isRemoteAudioEnabled(participantId)
}
// CHAT

const onMessageReceive = (cb) => {
    WT.SessionListeners.onMessageReceived(cb)
}
const setMessageToChat = (message) => {
    WT.Session.sendMessage(message);
}
const isAudioEnabled = () => {
   return WT.Participant.isAudioEnabled()
}
const isVideoEnabled = () => {
    return WT.Participant.isVideoEnabled()
}

// DEVICES
const getDevicesList = async () => {
    return await WT.getMediaDevices()
}
const onDevicesUpdate = (cb) => {
    WT.onDeviceListUpdates(cb)
}
const changeMediaDevices = async (value, type, localPId) => {
  await WT.ChangeMediaDevices(value, type, localPId)
}
// PREVIEW

const doPreview = async (constraints) => {
   return await WT.doPreview(constraints)
}
export {
    connect,
    disconnect,
    connectAsViewer,
    connectWithoutPublish,
    listenWtError,
    onConnected,
    onLocalConnectionResumed,
    onStreamCreated,
    onParticipantLeft,
    onParticipantJoin,
    onParticipantRejected,
    disconnectRemoteP,
    publishRemoteParticipant,
    onLocalStreamCreated,
    onMessageReceive,
    setMessageToChat,
    enableVideo,
    enableAudio,
    disableVideo,
    disableAudio,
    startScreenSharing,
    stopScreenSharing,
    isAudioEnabled,
    isVideoEnabled,
    enableWTStats,
    onMosReport,
    pStartSpeaking,
    pStopSpeaking,
    pMediaStreamChanged,
    toggleWTRemoteAudio,
    toggleWTRemoteVideo,
    isRemoteWTVideoEnabled,
    isRemoteWTAudioEnabled,
    getDevicesList,
    onDevicesUpdate,
    changeMediaDevices,
    doPreview,
    setWTAudioConstraints,
    setWTVideoConstraints,
    setMediaQuality,
    enableWTVideoStats,
    disableWTVideoStats,
}
